import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
const bezierConfig = { p0: 0.68, p1: -0.2, p2: 0.32, p3: 1.2 };
const sceneBackground = {
    variant: "insetBox",
    padding: "2%",
    borderRadius: "3rem",
    boxColor: ["#ffa400ee", "#2a251cee"],
};
const DOODLE_OBJECT_TRANSITION_FRAMES = 13;
const images = {
    coffee_1: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_1.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_1.png`,
        width: 125,
        height: 48,
    },
    coffee_2: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_2.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_2.webp`,
        width: 575,
        height: 548,
    },
    coffee_3: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_3.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_3.png`,
        width: 605,
        height: 529,
    },
    coffee_4: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_4.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_4.webp`,
        width: 521,
        height: 385,
    },
    coffee_5: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_5.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_5.png`,
        width: 275,
        height: 378,
    },
    coffee_6: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_6.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_6.webp`,
        width: 279,
        height: 437,
    },
    coffee_7: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_7.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_7.webp`,
        width: 424,
        height: 613,
    },
    coffee_8: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_8.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_8.png`,
        width: 161,
        height: 150,
    },
    coffee_9: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_9.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_9.png`,
        width: 421,
        height: 589,
    },
    coffee_10: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_10.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_10.webp`,
        width: 162,
        height: 408,
    },
    coffee_11: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_11.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_11.webp`,
        width: 330,
        height: 344,
    },
    coffee_12: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_12.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_12.png`,
        width: 253,
        height: 341,
    },
    coffee_13: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_13.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_13.webp`,
        width: 175,
        height: 169,
    },
    coffee_14: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_14.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_14.png`,
        width: 654,
        height: 819,
    },
    coffee_15: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_15.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_15.png`,
        width: 649,
        height: 853,
    },
    coffee_16: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_16.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_16.png`,
        width: 657,
        height: 709,
    },
    coffee_17: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_17.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_17.webp`,
        width: 517,
        height: 536,
    },
    coffee_18: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_18.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_18.webp`,
        width: 183,
        height: 410,
    },
    coffee_19: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_19.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_19.webp`,
        width: 279,
        height: 188,
    },
    coffee_20: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/coffee_20.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/doodle-coffee/optimized/coffee_20.png`,
        width: 100,
        height: 100,
    },
};
const messageAssets = [
    [
        {
            url: images.coffee_4,
            style: {
                zIndex: 10,
                translate: "-45% -45%",
                rotate: "45deg",
                scale: "0.14",
            },
            rotateNudgeOptions: {
                min: -10,
                max: 10,
            },
        },
        {
            url: images.coffee_7,
            style: {
                zIndex: 10,
                translate: "40% -20%",
                rotate: "-35deg",
                scale: "0.12",
            },
            rotateNudgeOptions: {
                min: -10,
                max: 10,
            },
        },
    ],
    [
        {
            url: images.coffee_2,
            style: {
                zIndex: 10,
                translate: "-42% -42%",
                rotate: "-20deg",
                scale: "0.12",
            },
            rotateNudgeOptions: {
                min: -10,
                max: 10,
            },
        },
        {
            url: images.coffee_11,
            style: {
                zIndex: 10,
                translate: "41% -4%",
                rotate: "180deg",
                scale: "0.12",
            },
            rotateNudgeOptions: {
                min: -10,
                max: 10,
            },
        },
    ],
    [
        {
            url: images.coffee_4,
            style: {
                zIndex: 10,
                translate: "-45% -45%",
                rotate: "45deg",
                scale: "0.14",
            },
            rotateNudgeOptions: {
                min: -10,
                max: 10,
            },
        },
        {
            url: images.coffee_7,
            style: {
                zIndex: 10,
                translate: "40% -20%",
                rotate: "-35deg",
                scale: "0.12",
            },
            rotateNudgeOptions: {
                min: -10,
                max: 10,
            },
        },
    ],
];
export const doodleCoffee = {
    version: 1,
    themeId: "doodle-coffee",
    name: "Doodle Coffee",
    endFadeDuration: 1,
    thumbnailFrame: 100,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/doodle-coffee.webp`,
    background: [
        {
            variant: "doodle",
            images: [
                {
                    src: images.coffee_2,
                    enter: {
                        start: {
                            frame: 25,
                            position: { x: 70, y: 100 },
                            rotation: 90,
                            scale: 0.65,
                        },
                        end: {
                            frame: 25 + DOODLE_OBJECT_TRANSITION_FRAMES,
                            position: { x: 52, y: 65 },
                            rotation: 0,
                        },
                    },
                    animate: {
                        rotate: 4,
                    },
                },
                {
                    src: images.coffee_3,
                    enter: {
                        start: {
                            frame: 20,
                            position: { x: -25, y: 100 },
                            rotation: 90,
                            scale: 0.65,
                        },
                        end: {
                            frame: 20 + DOODLE_OBJECT_TRANSITION_FRAMES,
                            position: { x: -5, y: 65 },
                            rotation: 30,
                        },
                    },
                    animate: {
                        rotate: 4,
                    },
                },
                {
                    src: images.coffee_4,
                    enter: {
                        start: {
                            frame: 25,
                            position: { x: 70, y: -40 },
                            rotation: 30,
                            scale: 0.65,
                        },
                        end: {
                            frame: 25 + DOODLE_OBJECT_TRANSITION_FRAMES,
                            position: { x: 57, y: -10 },
                            rotation: 0,
                        },
                    },
                    animate: {
                        rotate: 4,
                    },
                },
                {
                    src: images.coffee_5,
                    enter: {
                        start: {
                            frame: 15,
                            position: { x: 110, y: -40 },
                            rotation: 30,
                            scale: 0.5,
                        },
                        end: {
                            frame: 15 + DOODLE_OBJECT_TRANSITION_FRAMES,
                            position: { x: 92, y: -11 },
                            rotation: 10,
                        },
                    },
                    animate: {
                        rotate: 4,
                    },
                },
                {
                    src: images.coffee_6,
                    enter: {
                        start: {
                            frame: 23,
                            position: { x: -40, y: 30 },
                            rotation: 10,
                            scale: 0.6,
                        },
                        end: {
                            frame: 23 + DOODLE_OBJECT_TRANSITION_FRAMES,
                            position: { x: -2, y: 45 },
                            rotation: 70,
                        },
                    },
                    animate: {
                        rotate: 4,
                    },
                },
                {
                    src: images.coffee_7,
                    enter: {
                        start: {
                            frame: 13,
                            position: { x: -40, y: -40 },
                            rotation: -30,
                            scale: 0.6,
                        },
                        end: {
                            frame: 13 + DOODLE_OBJECT_TRANSITION_FRAMES,
                            position: { x: -7, y: -10 },
                            rotation: 0,
                        },
                    },
                    animate: {
                        rotate: 4,
                    },
                },
                {
                    src: images.coffee_8,
                    enter: {
                        start: {
                            frame: 23,
                            position: { x: 110, y: 40 },
                            rotation: -30,
                            scale: 0.65,
                        },
                        end: {
                            frame: 23 + DOODLE_OBJECT_TRANSITION_FRAMES,
                            position: { x: 93, y: 20 },
                            rotation: -60,
                        },
                    },
                    animate: {
                        rotate: 4,
                    },
                },
                {
                    src: images.coffee_9,
                    enter: {
                        start: {
                            frame: 17,
                            position: { x: 110, y: -40 },
                            rotation: -30,
                            scale: 0.7,
                        },
                        end: {
                            frame: 17 + DOODLE_OBJECT_TRANSITION_FRAMES,
                            position: { x: 75, y: -10 },
                            rotation: 0,
                        },
                    },
                    animate: {
                        rotate: 4,
                    },
                },
                {
                    src: images.coffee_10,
                    enter: {
                        start: {
                            frame: 15,
                            position: { x: 30, y: 100 },
                            rotation: 30,
                            scale: 0.65,
                        },
                        end: {
                            frame: 15 + DOODLE_OBJECT_TRANSITION_FRAMES,
                            position: { x: 25, y: 75 },
                            rotation: 0,
                        },
                    },
                    animate: {
                        rotate: 4,
                    },
                },
                {
                    src: images.coffee_11,
                    enter: {
                        start: {
                            frame: 20,
                            position: { x: 18, y: -30 },
                            rotation: 60,
                            scale: 0.7,
                        },
                        end: {
                            frame: 20 + DOODLE_OBJECT_TRANSITION_FRAMES,
                            position: { x: 11, y: -4 },
                            rotation: 0,
                        },
                    },
                    animate: {
                        rotate: 4,
                    },
                },
                {
                    src: images.coffee_12,
                    enter: {
                        start: {
                            frame: 10,
                            position: { x: 12, y: -30 },
                            rotation: -30,
                            scale: 0.7,
                        },
                        end: {
                            frame: 10 + DOODLE_OBJECT_TRANSITION_FRAMES,
                            position: { x: 22, y: 5 },
                            rotation: 0,
                        },
                    },
                    animate: {
                        rotate: 4,
                    },
                },
                {
                    src: images.coffee_13,
                    enter: {
                        start: {
                            frame: 23,
                            position: { x: 85, y: 100 },
                            rotation: -30,
                            scale: 0.7,
                        },
                        end: {
                            frame: 23 + DOODLE_OBJECT_TRANSITION_FRAMES,
                            position: { x: 78, y: 88 },
                            rotation: 0,
                        },
                    },
                    animate: {
                        rotate: 4,
                    },
                },
                {
                    src: images.coffee_14,
                    enter: {
                        start: {
                            frame: 17,
                            position: { x: 25, y: -65 },
                            rotation: -10,
                            scale: 0.7,
                        },
                        end: {
                            frame: 17 + DOODLE_OBJECT_TRANSITION_FRAMES,
                            position: { x: 33, y: -30 },
                            rotation: 0,
                        },
                    },
                    animate: {
                        rotate: 4,
                    },
                },
                {
                    src: images.coffee_15,
                    enter: {
                        start: {
                            frame: 15,
                            position: { x: 100, y: 50 },
                            rotation: 20,
                            scale: 0.6,
                        },
                        end: {
                            frame: 15 + DOODLE_OBJECT_TRANSITION_FRAMES,
                            position: { x: 78, y: 45 },
                            rotation: -10,
                        },
                    },
                    animate: {
                        rotate: 4,
                    },
                },
                {
                    src: images.coffee_17,
                    enter: {
                        start: {
                            frame: 15,
                            position: { x: 40, y: 100 },
                            rotation: 20,
                            scale: 0.7,
                        },
                        end: {
                            frame: 15 + DOODLE_OBJECT_TRANSITION_FRAMES,
                            position: { x: 32, y: 65 },
                            rotation: -30,
                        },
                    },
                    animate: {
                        rotate: 4,
                    },
                },
                {
                    src: images.coffee_18,
                    enter: {
                        start: {
                            frame: 23,
                            position: { x: 22, y: -30 },
                            rotation: 170,
                            scale: 0.6,
                        },
                        end: {
                            frame: 23 + DOODLE_OBJECT_TRANSITION_FRAMES,
                            position: { x: 29, y: -13 },
                            rotation: 160,
                        },
                    },
                    animate: {
                        rotate: 4,
                    },
                },
                {
                    src: images.coffee_19,
                    enter: {
                        start: {
                            frame: 23,
                            position: { x: 60, y: -30 },
                            rotation: -80,
                            scale: 0.6,
                        },
                        end: {
                            frame: 23 + DOODLE_OBJECT_TRANSITION_FRAMES,
                            position: { x: 55, y: -10 },
                            rotation: -60,
                        },
                    },
                    animate: {
                        rotate: 4,
                    },
                },
            ],
        },
    ],
    scenes: [
        {
            type: "generalSolidIntro",
            durationSeconds: 5,
            transitionVariant: "type-on",
            faceCollage: {
                variant: "top-bottom-static",
                borderShape: "circle",
                startAtSeconds: 1,
                entrance: { variant: "random-pop-in", transitionDurationInFrames: 10 },
            },
            title: {
                fontFamily: "Glass Antiqua",
                fontSize: 170,
                fontWeight: "extralight",
                letterSpacing: "widest",
            },
        },
        {
            type: "greetingLinesAsScenes",
            variant: "intro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            showLogo: true,
            sceneBackground,
            messageAssets,
        },
        {
            type: "clip-series-basic",
            showLogo: true,
        },
        {
            type: "greetingLinesAsScenes",
            variant: "outro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            sceneBackground,
            messageAssets,
        },
        {
            type: "outro",
            colorVariant: "darkBlue",
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "black",
            fontFamily: "Glass Antiqua",
            fontWeight: "light",
            fontSize: 96,
            leading: 1.1,
            tracking: 0,
            custom: {
                textShadow: "0.5rem 0.5rem 0.5rem rgba(0,0,0,0.1)",
            },
        },
        clips: {
            textVariant: {
                variant: "slide-in-static",
                startOffsetSeconds: 1.5,
                entranceVariant: "jiggle-to-offset-left",
                cards: [
                    {
                        backgroundColor: "#fff",
                        backgroundOpacity: 1,
                        paddingLeft: "5rem",
                        paddingRight: "5rem",
                        paddingBottom: "5rem",
                        paddingTop: "5rem",
                        borderWidth: "2px",
                        borderRadius: "2rem",
                        borderColor: "#000",
                        doodleImages: [
                            //
                            // upper right
                            //
                            // dots
                            {
                                url: images.coffee_1,
                                displaySize: {
                                    width: 60,
                                },
                                style: {
                                    top: "20px",
                                    right: "15px",
                                    transform: "rotate(-160deg)",
                                },
                            },
                            // petal
                            {
                                url: images.coffee_20,
                                displaySize: {
                                    width: 35,
                                },
                                style: {
                                    top: "27px",
                                    right: "41px",
                                    transform: "rotate(-105deg)",
                                },
                            },
                            // petal
                            {
                                url: images.coffee_20,
                                displaySize: {
                                    width: 40,
                                },
                                style: {
                                    top: "50px",
                                    right: "12px",
                                    transform: "rotate(110deg) scaleX(-1)",
                                },
                            },
                            //
                            // bottom right
                            //
                            // two springs
                            {
                                url: images.coffee_18,
                                displaySize: {
                                    width: 100,
                                },
                                overflow: "visible",
                                style: {
                                    bottom: "-40px",
                                    right: "0px",
                                    transform: "rotate(50deg)",
                                },
                            },
                            // paired leaves sprig
                            {
                                url: images.coffee_10,
                                displaySize: {
                                    width: 60,
                                },
                                style: {
                                    bottom: "-40px",
                                    right: "180px",
                                    transform: "rotate(-90deg) scaleX(-1)",
                                },
                            },
                            // dots
                            {
                                url: images.coffee_1,
                                displaySize: {
                                    width: 60,
                                },
                                style: {
                                    bottom: "70px",
                                    right: "75px",
                                    transform: "rotate(-70deg)",
                                },
                            },
                        ],
                    },
                ],
            },
            betweenTransition: {
                variant: "scale",
                timing: {
                    variant: "bezier",
                    config: bezierConfig,
                    durationSeconds: 0.5,
                },
            },
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 0.95,
                textColor: "#2b261f",
                fontFamily: "Oswald",
                fontWeight: "normal",
                fontSize: 60,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#fff",
                backgroundOpacity: 0.95,
                textColor: "#2b261f",
                fontFamily: "Oswald",
                fontWeight: "light",
                fontSize: 40,
                nudge: 2,
                textTransform: "none",
            },
            scaleFactor: 0.9,
            borderRadius: "3rem",
            boxShadow: "0.25rem 0.25rem 1.125rem 0px rgba(0,0,0,0.75)",
            border: "0.25rem solid #232626",
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
            exitTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
        },
        sceneTransition: {
            variant: "scale",
            timing: {
                variant: "bezier",
                config: bezierConfig,
                durationSeconds: 0.5,
            },
        },
    },
    userInputFields: [
        {
            id: "titleMessage",
            type: "text",
            label: "Title Message",
            defaultValue: "",
            placeholder: "Thank You, Jane!",
            required: true,
            min: 1,
            max: 35,
            preview: {
                sceneIndex: 0,
                frameOffset: 50,
            },
        },
    ],
    colorPalettes: ["DoodleCoffee"],
};
